export type ConsentCoveragePoint = { bucket: string; total: number; tc: number; gpp: number };

export async function fetchConsentCoverage(
  baseUrl: string,
  siteKey?: string,
  fromISO?: string,
  toISO?: string,
): Promise<ConsentCoveragePoint[]> {
  const url = new URL('/api/admin/analytics/consent', baseUrl);
  if (siteKey) url.searchParams.set('siteKey', siteKey);
  if (fromISO) url.searchParams.set('from', fromISO);
  if (toISO) url.searchParams.set('to', toISO);
  const r = await fetch(url.toString(), { credentials: 'include' });
  if (!r.ok) throw new Error(`analytics coverage failed: ${r.status}`);
  return r.json();
}

export type ExperimentVariantRow = {
  exp: string;
  variant: string;
  view: number;
  accept: number;
  reject: number;
  settings: number;
};

export async function fetchExperimentsSummary(
  baseUrl: string,
  siteKey: string,
  exp?: string,
  fromISO?: string,
  toISO?: string,
): Promise<{ experiments: ExperimentVariantRow[] }> {
  const url = new URL('/api/admin/analytics/experiments', baseUrl);
  if (siteKey) url.searchParams.set('siteKey', siteKey);
  if (exp) url.searchParams.set('exp', exp);
  if (fromISO) url.searchParams.set('from', fromISO);
  if (toISO) url.searchParams.set('to', toISO);
  const r = await fetch(url.toString(), { credentials: 'include' });
  if (!r.ok) throw new Error(`experiments summary failed: ${r.status}`);
  return r.json();
}

export type ExperimentSeriesPoint = {
  bucket: string;
  view: number;
  accept: number;
  reject: number;
  settings: number;
};

export async function fetchExperimentsSeries(
  baseUrl: string,
  siteKey: string,
  exp: string,
  variant: string,
  fromISO?: string,
  toISO?: string,
  bucket: 'day' | 'hour' = 'day',
): Promise<ExperimentSeriesPoint[]> {
  const url = new URL('/api/admin/analytics/experiments/series', baseUrl);
  if (siteKey) url.searchParams.set('siteKey', siteKey);
  url.searchParams.set('exp', exp);
  url.searchParams.set('variant', variant);
  url.searchParams.set('bucket', bucket);
  if (fromISO) url.searchParams.set('from', fromISO);
  if (toISO) url.searchParams.set('to', toISO);
  const r = await fetch(url.toString(), { credentials: 'include' });
  if (!r.ok) throw new Error(`experiments series failed: ${r.status}`);
  return r.json();
}
